<div class="page_wrapper">
  <app-header-new></app-header-new>
  <div class="container-fluid wrapper-page header-fix position-relative display-contents">
    <div class="container mt-5">
      <div class="row justify-content-center ">
        <div class="col-md-5">
          <img src="/assets/images/forgot-pass.png" class="w-100" />
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-5 mt-4 mt-md-0">
          <p class="text-color font-size-30 font-weight-500">FORGOT PASSWORD</p>
          <p class="text-change font-size-15 font-weight-500">Enter Email Address associated with your account.</p>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" [(ngModel)]="user['account_type']"
              id="inlineRadio1" value="patient">
            <label class="form-check-label  font-size-15 font-weight-500" for="inlineRadio1">Patient</label>
          </div>
          <div class="form-check form-check-inline ml-5">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" [(ngModel)]="user['account_type']"
              id="inlineRadio2" value="healthcare_provider" [checked]="true">
            <label class="form-check-label  font-size-15 font-weight-500" for="inlineRadio2">Healthcare
              Provider</label>
          </div>
          <!-- <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="inlineRadio1" value="patient">
              <label class="form-check-label font-size-15 font-weight-500" for="inlineRadio1">Patient</label>
            </div>
            <div class="form-check form-check-inline ml-5">
              <input class="form-check-input" type="radio" id="inlineRadio2" value="healthcare_provider">
              <label class="form-check-label font-size-15 font-weight-500" for="inlineRadio2">Healthcare
                Provider</label>
            </div>
          </div> -->
          <div class="form-group mt-4 inputWithIcon position-relative">
            <input type="text" required [(ngModel)]="user['email_id']" name="email_id" #email_id="ngModel"
              placeholder="Registered Email Address" class="form-control ">
            <i class="fa fa-lock text-color-font fa-lg position-absolute"></i>
          </div>
          <button type="submit" class="btn btn-primary w-100 mt-4" (click)="lookUp()" value="">CLAIM PASSWORD</button>
          <p class="text-center mt-4 text-change font-size-17">Remember Password?
            <span class="link"><a routerLink="/login" routerLinkActive="active"> Sign In </a></span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>